import {
  Button,
  Col,
  Descriptions,
  Divider,
  Icons,
  PageHeader,
  Table,
  Row,
  DateField,
  CreateButton,
  useModalForm,
  Menu,
  Tabs,
  List,
  Typography,
  Tag,
  Space,
  Modal,
  FormProps,
  ModalProps,
  Select,
  Form,
  Popover,
  message,
  Tooltip,
} from '@pankod/refine-antd'
import { BaseKey, useCreate, useGetIdentity, useList, useMany, useNavigation, useShow, useTable } from '@pankod/refine-core'
import { findAlreadyAssignPaperForTestEvent, findEvaluationRequestOfAssignedPaper, getTestEventById } from 'gql/query'
import { IProduct, ISection, ISubject, ITestEvent, ITestTrack, IPaper, ITestEventAssignedPapers } from 'interfaces'
import { useEffect, useState } from 'react'
import { CreatePaperRequest } from 'pages/paperrequests'
import { PaperRequestTable } from 'components/paperrequests'
import { CreateEvaluationRequest } from 'pages/evaluation_requests'
import {
  MailOutlined,
  CarryOutOutlined,
  PaperClipOutlined,
  BarsOutlined,
  SettingOutlined,
  AppleOutlined,
  AndroidOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Papers } from 'pages/paperrequests/showPapers'
import { PapersTableList } from 'components/papers'
import { EvaluationRequestsList } from 'components/evaluation_requests'
import Permissions from 'permissions'
import { useUserContext } from 'context/user'
import TestEventSlotsShow from 'components/test_event_slots'
import dayjs from 'dayjs'

//metadata
import paperMetaData from 'metadata/paper'
import testEventMetaData from 'metadata/test_events'
import { TestTracksList } from 'pages/testtracks'
import testEventAssignedPapersMetaData from 'metadata/testEventAssignedPapers'
import TestEventCandidates from 'components/candidates/test_event_candidates'
import { deleteItemById } from 'gql/mutations'

const { TabPane } = Tabs
type Permission = {
  granted?: boolean
}
const { Text } = Typography

export const TestEventShow = () => {
  const { data: user } = useGetIdentity()
  const [showTestTrack, setShowTestTrack] = useState(false)
  const [showSection, setShowSection] = useState(false)
  const [sectionData, setSectionData] = useState<any[]>([])
  const [testEventData, setTestEventData] = useState<any[]>([])
  const [slots, setSlots] = useState<any[]>([])
  const [papersRequired, setPapersRequired] = useState<Number>(0)
  const [currentTab, setCurrentTab] = useState<string>('1')
  const { userRole } = useUserContext()
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  const { queryResult, showId } = useShow<ITestEvent>({
    resource: 'test_events',
    metaData: {
      fields: [
        'id',
        'name',
        'slots',
        'mode_of_exam',
        'location',
        'created_at',
        { product: ['name', 'test_track_ids', 'sections', 'section_ids', 'type'] },
        'product_id',
      ],
    },
  })
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('test_events'))
      setCreatePermission(Permissions.can(userRole).createAny('test_events'))
      setEditPermission(Permissions.can(userRole).updateAny('test_events'))
      setDeletePermission(Permissions.can(userRole).deleteAny('test_events'))
    }
  }, [userRole])
  // useEffect(() => {
  //   if (user !== undefined) {
  //     setReadPermission(Permissions.can(user?.roles).readAny('test_events'))
  //     setCreatePermission(Permissions.can(user?.roles).createAny('test_events'))
  //     setEditPermission(Permissions.can(user?.roles).updateAny('test_events'))
  //     setDeletePermission(Permissions.can(user?.roles).deleteAny('test_events'))
  //   }
  // }, [user])
  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data

  const { setFilters, tableQueryResult } = useTable<ITestTrack>({
    resource: 'test_tracks',
    initialSorter: [
      {
        field: 'name',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['name', 'id', 'subject_ids', 'grade_ids', 'in_use'],
    },
    // initialFilter: [{ field: 'id', operator: 'in', value: queryResult?.data?.data?.product?.test_track_ids}],
  })

  // list of papers in papers tab
  const { tableQueryResult: listOfPaperinTestEventQueryResult } = useTable<IPaper>({
    resource: 'papers',
    metaData: paperMetaData,
    permanentFilter: [
      { field: 'test_event_id', operator: 'eq', value: `${showId}` },
      { field: 'active', operator: 'eq', value: true },
    ],
    hasPagination: false,
    initialSorter: [{ field: 'created_at', order: 'desc' }],
    queryOptions: { staleTime: Infinity },
  })

  const { tableQueryResult: existingPapersQueryResult } = useTable<ITestEventAssignedPapers>({
    resource: 'test_event_assigned_papers',
    metaData: testEventAssignedPapersMetaData,
    hasPagination: false,
    permanentFilter: [
      { field: 'active', operator: 'eq', value: true },
      { field: 'test_event_id', operator: 'eq', value: record?.id },
    ],
    queryOptions: { enabled: !!record?.id, staleTime: Infinity },
  })

  const handleRefetchData = async () => {
    await existingPapersQueryResult.refetch()
  }
  // const listOfPapers = listOfPaperinTestEventQueryResult?.data?.data.map(({ paper_request, paper_template, product, paper_smart_id, id }) => {
  //   return { id, paper_request: paper_request.name, product: product.name, paper_template: paper_template.name, paper_smart_id }
  // })

  const { show, push } = useNavigation()

  const { setFilters: setSectionFilters, tableQueryResult: sectionResult } = useTable<ISection>({
    resource: 'sections',
    metaData: {
      fields: ['name', 'id'],
    },
  })

  const onChangeTab = (value: string) => {
    setCurrentTab(value)
  }

  const getTestEventDeatilsbyId = () => {
    getTestEventById(showId).then((resp: any) => {
      setTestEventData(resp?.test_events[0])
      setSectionData(resp?.test_events[0]?.product?.sections)
      setSlots(resp?.test_events[0]?.slots)
    })
  }

  useEffect(() => {
    // getTestEventById(showId).then((resp: any) => {
    //   setTestEventData(resp?.test_events[0])
    //   setSectionData(resp?.test_events[0]?.product?.sections)
    //   setSlots(resp?.test_events[0]?.slots)
    // })
    getTestEventDeatilsbyId()
  }, [showId])
  useEffect(() => {
    setFilters([
      {
        field: 'id',
        operator: 'in',
        value: record?.product?.test_track_ids,
      },
    ])
    setShowTestTrack(true)
  }, [record])
  useEffect(() => {
    let arr: object[] = []
    if (JSON.stringify(record?.product?.sections) !== '{}') {
      record?.product?.sections?.map((item: any) => {
        if (!arr.includes(item?.section_id)) {
          arr.push(item?.section_id)
        }
      })
    }
    setSectionFilters([
      {
        field: 'id',
        operator: 'in',
        value: arr,
      },
    ])
    setShowSection(true)
  }, [record])

  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
  }, [readPermission])

  useEffect(() => {
    const listOfAllSlots: any[] = []
    //use effect to get number of papers required
    record?.slots?.forEach((eachTestTrackSlotData: any) => {
      const data = eachTestTrackSlotData?.list_of_slots
      if (data) {
        listOfAllSlots.push(...data)
      }
    })
    setPapersRequired(listOfAllSlots.length)
  }, [record])

  const renderQuestionNumber = (item: any) => {
    let numberOfQuestions = 0
    if (sectionData?.length > 0) {
      numberOfQuestions = sectionData.filter((section: any) => section?.section_id === item?.id)[0]?.no_of_questions
    }
    return numberOfQuestions
  }
  const renderMarkPerQuestion = (item: any) => {
    let marks = 0
    if (sectionData?.length > 0) {
      marks = sectionData.filter((section: any) => section?.section_id === item?.id)[0]?.marks
    }
    return marks
  }

  const {
    formProps: createFormProps,
    modalProps: createModalProps,
    close: createClose,
    show: createShow,
  } = useModalForm({
    resource: 'paper_requests',
    action: 'create',
    redirect: false,
  })
  const {
    formProps: createSlotFormProps,
    modalProps: createSlotModalProps,
    close: createSlotClose,
    show: createSlotShow,
  } = useModalForm({
    resource: 'evaluation_requests',
    action: 'create',
    redirect: false,
  })
  const {
    formProps: existingPapersCreateFormProps,
    modalProps: existingPapersCreateModalProps,
    close: existingPapersModalClose,
    show: existingPapersModalShow,
  } = useModalForm<ITestEventAssignedPapers>({
    resource: 'test_events_assigned_papers',
    action: 'create',
    redirect: false,
    metaData: { fields: ['id', 'created_at', 'updated_at', 'test_event_id', 'product_id', 'paper_id', 'slot_assigned', 'active'] },
  })

  const subjectLists = useList<ISubject>({
    resource: 'subjects',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      pagination: { pageSize: 1000 },
    },
  })
  const renderSubjects = (item: any) => {
    let subject_text: string = ''
    for (let i = 0; i < item?.subject_ids?.length; i++) {
      let result = subjectLists?.data?.data?.filter((subjects: any) => item?.subject_ids[i] === subjects?.id)[0]
      if (result !== undefined) {
        subject_text = subject_text?.concat(result?.name)
        subject_text = subject_text.concat(',')
      }
    }
    subject_text = subject_text.substring(0, subject_text.length - 1)
    return subject_text
  }
  return (
    <>
      {readPermission?.granted ? (
        <PageHeader
          className="site-page-header-responsive"
          ghost={false}
          title={`${record?.name}`}
          extra={[
            <>
              <Button key="close" onClick={() => window.history.back()} icon={<Icons.LeftOutlined />}>
                Back
              </Button>

              {userRole !== 'deliverymanager' && readPermission?.granted ? (
                <Button
                  key="create"
                  type="primary"
                  icon={<Icons.PlusOutlined />}
                  onClick={() => {
                    createFormProps?.form?.resetFields()
                    createShow()
                  }}
                >
                  Send Paper Request
                </Button>
              ) : null}

              {userRole === 'admin' || userRole === 'productmanager' ? (
                <Button
                  icon={<Icons.DiffOutlined />}
                  key="assign existing papers"
                  type="primary"
                  onClick={() => {
                    existingPapersModalShow()
                  }}
                >
                  Assign Existing Paper
                </Button>
              ) : null}
              {/* <Button
              key="create"
              type="primary"
              icon={<Icons.PlusOutlined />}
              onClick={() => {
                createSlotFormProps?.form?.resetFields()
                createSlotShow()
              }}
            >
              Assign Evaluation Slot
            </Button> */}
            </>,
          ]}
        >
          <Descriptions size="small" column={3}>
            <Descriptions.Item label="Product Name">{record?.product?.name}</Descriptions.Item>
            <Descriptions.Item label="Location">{record?.location}</Descriptions.Item>
            <Descriptions.Item label="Mode Of Exam">{record?.mode_of_exam}</Descriptions.Item>
            <Descriptions.Item label="Number of required papers">{papersRequired}</Descriptions.Item>
          </Descriptions>
          <Divider style={{ margin: ' 0', paddingBottom: 5 }} />

          <Row gutter={20}>
            <Col lg={12} xs={24}>
              <b>Slot Details</b>
              {/* <div style={{ marginTop: 5 }}>
              <Table
                style={{ display: 'inline-block', minWidth: '300px' }}
                // showHeader={false}
                size="small"
                bordered
                dataSource={slots}
                pagination={false}
                columns={[
                  {
                    title: 'Id',
                    dataIndex: '',
                    render: (item, record, index) => <>{index + 1}</>,
                  },
                  {
                    title: 'Slot Selected',
                    dataIndex: 'name',
                    render: (item, record, index) => (
                      <>
                        <DateField value={record} format="LLL" />
                      </>
                    ),
                  },
                ]}
              />
            </div> */}

              <TestEventSlotsShow listOfSlots={slots} style={{ minWidth: '300px', marginTop: 5, marginBottom: 10 }} />
            </Col>

            <Col lg={12} xs={24}>
              <b>Test Track Details:</b>
              <div style={{ marginTop: 5 }}>
                {
                  // removing showTestTrack &&
                  <Table
                    style={{ display: 'inline-block', minWidth: '300px' }}
                    // showHeader={false}
                    size="small"
                    bordered
                    dataSource={tableQueryResult?.data?.data}
                    // pagination={false}
                    columns={[
                      {
                        title: 'Id',
                        dataIndex: '',
                        render: (item, record, index) => <>{index + 1}</>,
                      },
                      {
                        title: 'Test Track Name',
                        dataIndex: 'name',
                        render: text => <>{` ${text}`}</>,
                      },
                      {
                        title: 'Subject Name',
                        dataIndex: 'subject',
                        render: (_, record) => renderSubjects(record),
                      },
                    ]}
                  />
                }
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={8} xs={24}>
              <b>Product Paper Format:</b>
              <div style={{ marginTop: 5 }}>
                {showSection && (
                  <Table
                    style={{ display: 'inline-block', minWidth: '300px' }}
                    // showHeader={false}
                    size="small"
                    bordered
                    dataSource={sectionResult?.data?.data}
                    pagination={false}
                    columns={[
                      {
                        title: 'Id',
                        dataIndex: '',
                        render: (item, record, index) => <>{index + 1}</>,
                      },
                      {
                        title: 'Section Name',
                        dataIndex: 'name',
                        render: text => <>{` ${text}`}</>,
                      },
                      {
                        title: 'No Of Questions',
                        dataIndex: 'no_of_questions',
                        render: (item, record, index) => <>{renderQuestionNumber(record)}</>,
                      },
                      {
                        title: 'Mark Per Question',
                        dataIndex: 'marks',
                        render: (item, record, index) => <>{renderMarkPerQuestion(record)}</>,
                      },
                    ]}
                  />
                )}
              </div>
            </Col>
          </Row>

          <Divider style={{ margin: ' 0', paddingBottom: 5 }} />

          <Tabs
            defaultActiveKey="2"
            activeKey={userRole === 'deliverymanager' || userRole === 'evaluationincharge' || userRole === 'evaluators' ? '4' : currentTab}
            onChange={value => onChangeTab(value)}
          >
            {readPermission !== undefined &&
            readPermission.granted &&
            userRole !== 'deliverymanager' &&
            userRole !== 'evaluationincharge' &&
            userRole !== 'evaluators' ? (
              <TabPane
                tab={
                  <span>
                    <BarsOutlined />
                    Paper Requests
                  </span>
                }
                key="1"
              >
                <PaperRequestTable request={testEventData} />
              </TabPane>
            ) : null}
            {readPermission !== undefined &&
            readPermission.granted &&
            userRole !== 'deliverymanager' &&
            userRole !== 'evaluationincharge' &&
            userRole !== 'evaluators' ? (
              <TabPane
                tab={
                  <span>
                    <PaperClipOutlined />
                    Papers
                  </span>
                }
                key="2"
              >
                {/* {true ? <Papers request={testEventData} /> : <PapersTableList />} */}
                <List title="Papers">
                  <Table
                    size="small"
                    dataSource={listOfPaperinTestEventQueryResult?.data?.data}
                    columns={[
                      {
                        title: 'Id',
                        dataIndex: ['id', 'paper_smart_id'],
                        render: (_, value) =>
                          value?.paper_request?.created_by === user?.id || userRole === 'admin' ? (
                            <Typography.Link onClick={() => show('papers', value.id)}>
                              #{value?.paper_id} {value.paper_smart_id}
                            </Typography.Link>
                          ) : (
                            <Typography.Text>
                              #{value?.paper_id} {value?.paper_smart_id}
                            </Typography.Text>
                          ),
                      },
                      {
                        title: 'Status',
                        dataIndex: 'status',
                        render(value, record, index) {
                          const color = value === 'Open' ? 'blue' : value === 'For Approval' ? 'blue' : value === 'Approved' ? 'green' : 'blue'
                          return (
                            <Tag key={index} color={color}>
                              {value}
                            </Tag>
                          )
                        },
                      },
                      { title: 'Product', dataIndex: ['product', 'name'] },
                      { title: 'Paper Template', dataIndex: ['paper_template', 'name'] },
                      { title: 'Paper Request', dataIndex: ['paper_request', 'name'] },
                      {
                        title: 'Date',
                        dataIndex: 'slot_data',
                        render(value, record, index) {
                          if (value !== undefined) {
                            const data = JSON.parse(value)
                            return <DateField value={data?.date} format="LL" />
                          }
                        },
                      },
                      {
                        title: 'Time',
                        dataIndex: 'slot_data',
                        render(value, record, index) {
                          if (value !== undefined) {
                            const data = JSON.parse(value)
                            return (
                              <Tag>
                                <Space>
                                  <DateField value={data?.start_time} format="LT" />
                                  <span>To</span>
                                  <DateField value={data?.end_time} format="LT" />
                                </Space>
                              </Tag>
                            )
                          }
                        },
                      },
                    ]}
                  />
                </List>
              </TabPane>
            ) : null}
            {readPermission !== undefined &&
            readPermission.granted &&
            userRole !== 'deliverymanager' &&
            userRole !== 'evaluationincharge' &&
            userRole !== 'evaluators' ? (
              <TabPane
                tab={
                  <span>
                    <UserOutlined />
                    Candidates
                  </span>
                }
                key="3"
              >
                <TestEventCandidates
                  testEvent={record}
                  oldPapers={existingPapersQueryResult?.data?.data}
                  newPapers={listOfPaperinTestEventQueryResult?.data?.data}
                  testTrackList={tableQueryResult?.data?.data}
                  key="3"
                />

                <Table.Column title="Stage" />
              </TabPane>
            ) : null}
            {readPermission !== undefined && readPermission.granted ? (
              <TabPane
                tab={
                  <span>
                    <SettingOutlined />
                    Evaluation
                  </span>
                }
                key="4"
              >
                <EvaluationRequestsList request={testEventData} />

                <Table.Column title="Stage" />
              </TabPane>
            ) : null}
            {/* {readPermission !== undefined && readPermission.granted ? (
              <TabPane
                tab={
                  <span>
                    <CarryOutOutlined />
                    Report Generation
                  </span>
                }
                key="4"
              >
                Report Generation
              </TabPane>
            ) : null} */}
          </Tabs>

          {/* <PaperRequestTable request={testEventData} /> */}
          <CreatePaperRequest
            modalProps={createModalProps}
            formProps={createFormProps}
            record={testEventData}
            close={createClose}
            setCurrentTab={setCurrentTab}
            fetchTestEventDetails={getTestEventDeatilsbyId}
          />
          <CreateEvaluationRequest modalProps={createSlotModalProps} formProps={createSlotFormProps} record={testEventData} userRole={userRole} />
          <ExistingPapersModal
            testTracksList={tableQueryResult?.data?.data}
            existingPapersAssignedList={existingPapersQueryResult?.data?.data}
            request={record}
            existingPaperModalProps={existingPapersCreateModalProps}
            existingPaperFormProps={existingPapersCreateFormProps}
            refechExistingPapers={handleRefetchData}
            userRole={userRole}
          />
        </PageHeader>
      ) : null}
    </>
  )
}

type existingPaperModalProps = {
  request: ITestEvent | undefined
  existingPaperFormProps: FormProps
  existingPaperModalProps: ModalProps
  existingPapersAssignedList: ITestEventAssignedPapers[] | undefined
  testTracksList: ITestTrack[] | undefined
  refechExistingPapers: () => Promise<void>
  userRole: string
}

function ExistingPapersModal({
  request,
  existingPaperFormProps,
  existingPaperModalProps,
  existingPapersAssignedList,
  testTracksList,
  refechExistingPapers,
  userRole,
}: existingPaperModalProps) {
  //all states go here
  const [newListOfAssignedPapers, setNewListOfAssignedPapers] = useState<object[]>([])
  const [disableSlotField, setDisableSlotField] = useState<boolean>(true)
  const [selectedTestTrack, setSelectedTestTrack] = useState<string>('')
  const [validdataSource, setValidDataSource] = useState<any[]>([])

  const { mutateAsync: mutationAssignNewPaper } = useCreate()

  const { tableQueryResult: listOfPapersQueryResult, setFilters: setListOfPapersFilter } = useTable<IPaper>({
    resource: 'papers',
    metaData: paperMetaData,
    permanentFilter: [
      { field: 'status', operator: 'eq', value: 'Approved' },
      { field: 'test_event_id', operator: 'ne', value: request?.id },
      { field: 'product_id', operator: 'eq', value: request?.product_id },
      { field: 'active', operator: 'eq', value: true },
      { field: 'id', operator: 'nin', value: existingPapersAssignedList?.map(paper => paper?.paper_id) },
      { field: 'in_use', operator: 'eq', value: true },
      { field: 'is_disabled', operator: 'eq', value: false },
    ],
    queryOptions: { enabled: !!request?.id && !!existingPaperModalProps?.visible },
  })
  useEffect(() => {
    const processData = async () => {
      if (existingPapersAssignedList && existingPapersAssignedList.length > 0) {
        const processedData = await Promise.all(
          existingPapersAssignedList.map(async record => {
            let testEventId = record?.test_event_id
            let paperId = record?.paper_id
            let evaluationRequests: any = testEventId && paperId ? await findEvaluationRequestOfAssignedPaper(paperId, testEventId) : false
            //if evaluation request is present then we are disabling the delete button
            let isValid = evaluationRequests && evaluationRequests?.evaluation_requests?.length > 0 ? true : false

            return { ...record, isValid }
          })
        )
        setValidDataSource(processedData)
      }
    }
    processData()
  }, [existingPapersAssignedList, userRole])

  // list of paper that are available to be assigned
  let listOfPapers = listOfPapersQueryResult?.data?.data

  const RenderSlot = ({ data, disabled }: { data: any; disabled: boolean }) => {
    return (
      <>
        <DateField value={data?.date} format="LL" disabled={disabled} />
        <Tag>
          <Space>
            <DateField value={data?.start_time} format="LT" disabled={disabled} />
            <Text disabled={disabled}>To</Text>
            <DateField value={data?.end_time} format="LT" disabled={disabled} />
          </Space>
        </Tag>
      </>
    )
  }

  const handleAddNewPaper = (selectedPaperId: string | BaseKey) => {
    const selectedPaper = listOfPapers?.filter(eachPaper => eachPaper?.id === selectedPaperId)[0]
    setListOfPapersFilter([{ field: 'id', operator: 'ne', value: selectedPaperId }], 'merge')
    existingPaperFormProps?.form?.submit()
  }

  const handleTestTrackChange = (testTrackId: string) => {
    setListOfPapersFilter([{ field: 'test_track_id', operator: 'eq', value: testTrackId }])
  }

  const onFinish = async (values: any) => {
    await mutationAssignNewPaper({
      resource: 'test_event_assigned_papers',
      values: { ...values, product_id: request?.product_id, test_event_id: request?.id },
    })
    existingPaperFormProps?.form?.resetFields()
    listOfPapersQueryResult?.refetch()
  }

  const handleDelete = async (details: any) => {
    const id = details?.id
    const result: any = await deleteItemById(id, 'test_event_assigned_papers')
    if (result?.delete_test_event_assigned_papers_by_pk?.id) {
      await refechExistingPapers()
      const removedPaperId = details?.paper_id
      //removing that removed paperId from the select paper filter
      setListOfPapersFilter(prevFilters =>
        prevFilters.filter(filter => {
          if ('field' in filter) {
            return !(filter.field === 'id' && filter.operator === 'ne' && filter.value === removedPaperId)
          }
          return true
        })
      )

      message.success('item deleted successfully!')
    } else {
      message.error("can't delete now!")
    }
  }
  return (
    <Modal
      {...existingPaperModalProps}
      title="Assign Existing Papers"
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      afterClose={() => {
        existingPaperFormProps?.form?.resetFields()
        setDisableSlotField(true)
      }}
    >
      <Table
        bordered
        dataSource={existingPapersAssignedList}
        // footer={() => {
        //   return (
        //     <Col lg={24} span={22}>
        //       <Select style={selectBoxStyling}></Select>
        //       <Select style={selectBoxStyling}></Select>
        //       <Select style={selectBoxStyling}></Select>
        //       <Button type="primary" size="small">
        //         Add
        //       </Button>
        //     </Col>
        //   )
        // }}
      >
        <Table.Column
          dataIndex={'paper'}
          title="Paper Id"
          render={(_, record: any) => {
            return (
              <Typography.Text>
                {record?.paper?.name
                  ? `${record?.paper?.name}-(PID-${record?.paper?.paper_id})`
                  : `#${record?.paper?.paper_id} ${record?.paper?.paper_smart_id}`}
              </Typography.Text>
            )
          }}
        />
        <Table.Column
          dataIndex={'test_track'}
          title="Test Track"
          render={(_, record: any) => {
            return <Typography.Text>{record?.test_track?.name}</Typography.Text>
          }}
        />
        <Table.Column
          dataIndex={'slot_assigned'}
          title="Slot Assigned"
          render={(value, record: any) => {
            const timeSlotData = JSON.parse(value)
            return (
              <Space>
                <Tag>
                  <DateField format="LL" value={timeSlotData?.date} />
                </Tag>
                <Tag>
                  <Space>
                    <DateField format="LT" value={timeSlotData?.start_time} />
                    <span>To</span>
                    <DateField format="LT" value={timeSlotData?.end_time} />
                  </Space>
                </Tag>
              </Space>
            )
          }}
        />
        <Table.Column
          dataIndex={'id'}
          title="Actions"
          render={(value: string, record: any) => {
            const validData = validdataSource.find((item: any) => item.id === value)
            return (
              <Button
                size="small"
                onClick={() => handleDelete(record)}
                style={{ color: 'red', visibility: validData?.isValid ? 'hidden' : 'visible' }}
                icon={<Icons.DeleteOutlined />}
              >
                Delete
              </Button>
            )
          }}
        />
      </Table>

      <Form
        {...existingPaperFormProps}
        onFinish={values => {
          onFinish(values)
        }}
      >
        <Row gutter={20}>
          <Col lg={7} sm={24}>
            <Form.Item label="Test Tracks" name="test_track_id" required>
              <Select
                showSearch
                onChange={value => {
                  setDisableSlotField(false)
                  existingPaperFormProps?.form?.setFieldsValue({ slot_assigned: '', paper_id: '' })
                  setSelectedTestTrack(value)
                  handleTestTrackChange(value)
                }}
                filterOption={(input, option) => (option?.label as string)?.toLowerCase().includes(input.toLowerCase())}
                options={testTracksList
                  ?.filter(testTrack => testTrack?.in_use === true) // 👈 filter added here
                  ?.map(testTrack => ({
                    label: testTrack?.name,
                    value: testTrack?.id,
                  }))}
              />
              {/* {testTracksList?.map((testTrack: any, idx: number) => (
                  <option key={idx} value={testTrack?.id}>
                    {testTrack?.name}
                  </option>
                ))} */}
              {/* </Select> */}
            </Form.Item>
          </Col>

          <Col lg={7} sm={24}>
            <Form.Item label="Paper" name="paper_id" required>
              <Select
                onChange={() => {
                  existingPaperFormProps?.form?.setFieldsValue({ slot_data: '' })
                }}
              >
                {listOfPapersQueryResult?.data?.data?.map((paper, idx: number) => {
                  const newDate = dayjs(paper?.updated_at).add(90, 'day')
                  const isExpired = dayjs().isAfter(newDate)
                  return (
                    <option key={idx} value={paper?.id}>
                      <Tooltip title={paper.name ? `${paper.name}-(PID-${paper?.paper_id})` : `#${paper?.paper_id} ${paper?.paper_smart_id}`}>
                        <span>
                          {isExpired ? (
                            <span style={{ color: 'red', marginRight: 5 }}>●</span>
                          ) : (
                            <span style={{ color: 'green', marginRight: 5 }}>●</span>
                          )}
                          {paper.name ? `${paper.name}-(PID-${paper?.paper_id})` : `#${paper?.paper_id} ${paper?.paper_smart_id}`}
                        </span>
                      </Tooltip>
                    </option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>

          <Col lg={7} sm={24}>
            <Form.Item label="Available Slots" name="slot_assigned" rules={[{ required: true }]}>
              <Select
                disabled={disableSlotField}
                onSelect={() => {
                  console.log('tsssst trrrackkk', typeof existingPaperFormProps?.form?.getFieldValue('test_track_id'))
                }}
              >
                {request?.slots
                  ?.filter((data: any) => data?.test_track_id === selectedTestTrack)[0]
                  ?.list_of_slots?.map((data: any, idx: number) => {
                    const disabled = dayjs(data?.date) < dayjs()
                    return (
                      <option key={idx} value={JSON.stringify(data)} disabled={disabled}>
                        <Space>
                          <Popover placement="left" content={<RenderSlot data={data} disabled={disabled} />}>
                            <DateField value={data?.date} format="LL" disabled={disabled} />
                            <Tag>
                              <Space>
                                <DateField value={data?.start_time} format="LT" disabled={disabled} />
                                <Text disabled={disabled}>To</Text>
                                <DateField value={data?.end_time} format="LT" disabled={disabled} />
                              </Space>
                            </Tag>
                          </Popover>
                        </Space>
                      </option>
                    )
                  })}
              </Select>
            </Form.Item>
          </Col>
          <Col lg={3}>
            <Button
              icon={<Icons.PlusOutlined />}
              type="primary"
              // {...existingPaperModalProps?.okButtonProps}
              onClick={() => {
                handleAddNewPaper(existingPaperFormProps?.form?.getFieldValue('paper_id'))
              }}
            >
              Add
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
